module.exports = __webpack_public_path__ + "img/417.f8b44ff7.jpg";